/* eslint-disable react/prefer-stateless-function */
import moment from 'moment';
import React from 'react';
import {
  IClientsData,
  IDateSearch,
} from '../../../../../../../../../../redux/duck/legado/clientsApp/interface/reduxInterface';
import {
  defineAccountType,
  setPartner,
} from '../../../../../../../../../../utils/businessRule';
import { agencyAccountMask } from '../../../../../../../../../../utils/masks';
import {
  Column,
  Data,
  Header,
  Logo,
  MainTitle,
  Page,
  PartnerAndTotalContainer,
  PartnerContainer,
  Row,
  Table,
  TableContainer,
  TotalLabel,
  TotolTitle,
} from '../styledComponent';

interface IClientsPdfSheet {
  totalBalance: number;
  data: IClientsData[];
  date: IDateSearch;
  state: any;
}

class ClientsPdfSheet extends React.Component<IClientsPdfSheet> {
  render() {
    return (
      <Page>
        <Header>
          <Logo />
          <MainTitle>Relatório de Clientes</MainTitle>
        </Header>
        <h3>{`Data da consulta: ${moment(this.props.date.end).format(
          'DD/MM/YYYY'
        )}`}</h3>

        <PartnerContainer>
          <PartnerAndTotalContainer>
            <TotalLabel>Total na CL:</TotalLabel>
            <TotolTitle>
              {this.props.totalBalance.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </TotolTitle>
          </PartnerAndTotalContainer>
        </PartnerContainer>
        <TableContainer>
          <Table>
            <thead>
              <Row>
                <Column>ID</Column>
                <Column>Nome</Column>
                <Column>CPF/CNPJ</Column>
                <Column>Parceiro</Column>
                <Column>Tipo de Conta</Column>
                <Column>Conta</Column>
                <Column>Aberto em</Column>
                <Column>Cidade</Column>
                <Column>Saldo</Column>
              </Row>
            </thead>
            <tbody>
              {this.props.data.map((data) => {
                return (
                  <Row key={data.id}>
                    <Data>{data.id}</Data>
                    <Data>{data.companyName}</Data>
                    <Data>{data.cpfCnpj}</Data>
                    <Data>{setPartner(data.partnerId, this.props.state)}</Data>
                    <Data>{defineAccountType(data.accountFormat)}</Data>
                    <Data>
                      {agencyAccountMask(data.agency, data.account, data.digit)}
                    </Data>
                    <Data>{data.createdAt}</Data>
                    <Data>{data.city}</Data>
                    <Data>
                      {data.balance.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Data>
                  </Row>
                );
              })}
            </tbody>
          </Table>
        </TableContainer>
      </Page>
    );
  }
}

export default ClientsPdfSheet;
